import { Wifi, Gauge, Plug, Thermometer, UtensilsCrossed, Droplets, Lightbulb, ShieldCheck, Layers } from 'lucide-react';
import { FEATURES } from '../mock';

const iconMap = { Wifi, Gauge, Plug, Thermometer, UtensilsCrossed, Droplets, Lightbulb, ShieldCheck, Layers };

export default function ModernSpace() {
  return (
    <section className="bg-[#f1ede5] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <span className="eyebrow">Modern Business Space</span>
          <h2 className="font-serif-display text-[42px] md:text-[54px] leading-[1.05] mt-6">
            Every unit designed<br />
            <em className="text-[#b39352] italic">around the occupier.</em>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-[#0d281e]/12">
          {FEATURES.map((f) => {
            const Icon = iconMap[f.icon];
            return (
              <div
                key={f.title}
                className="border-r border-b border-[#0d281e]/12 p-8 md:p-10 group hover:bg-[#e9e3d6] transition-colors duration-300"
              >
                <Icon size={28} strokeWidth={1.3} className="text-[#b39352] group-hover:scale-110 transition-transform duration-300" />
                <h3 className="font-serif-display text-[24px] mt-6 text-[#0d281e]">{f.title}</h3>
                <p className="mt-3 text-[13px] leading-[1.7] text-[#0d281e]/70">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
